import React, {useMemo} from "react";
import {useSelector} from "react-redux";

import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IRPStore} from "../../../../app/rp_reducer";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {findVariableByValue} from "../../../../property/utils/find_variable_by_value";

export const AdditionalAreasCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    const variables = useSelector((state: IRPStore) => state.variables.data);
    const additionalAreaList = useMemo(() => {
        return property.additional_areas
            .reduce((acc, additionalArea) => {
                const foundAdditionalArea = findVariableByValue(variables?.property_additional_areas, additionalArea.type as number);

                return foundAdditionalArea ? acc.concat(foundAdditionalArea.label.toLowerCase()) : acc;
            }, [] as string[])
            .join(", ");
    }, [property.additional_areas]);

    return <>{additionalAreaList}</>;
};
import React, {useMemo} from "react";
import {useSelector} from "react-redux";

import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IRPStore} from "../../../../app/rp_reducer";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {findVariableByValue} from "../../../../property/utils/find_variable_by_value";

export const AdditionalAreasCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    const variables = useSelector((state: IRPStore) => state.variables.data);
    const additionalAreaList = useMemo(() => {
        return property.additional_areas
            .reduce((acc, additionalArea) => {
                const foundAdditionalArea = findVariableByValue(variables?.property_additional_areas, additionalArea.type as number);

                return foundAdditionalArea ? acc.concat(foundAdditionalArea.label.toLowerCase()) : acc;
            }, [] as string[])
            .join(", ");
    }, [property.additional_areas]);

    return <>{additionalAreaList}</>;
};
